import type { GanttProfissionaisProps } from "./types-gantt-profissionais";
import { useGanttProfissionais } from "./use-gantt-profissionais";
import { GanttProfissionaisView } from "./view-gantt-profissionais";

export function GanttProfissionais(props: GanttProfissionaisProps) {
  const vm = useGanttProfissionais(props);

  return <GanttProfissionaisView {...vm} />;
}

export type * from "./types-gantt-profissionais";
